<template>
  <page>
    <div id="up" class="m-grid__item m-grid__item--fluid m-wrapper">

      <!-- BEGIN: Subheader -->
      <div class="m-subheader ">
        <div class="d-flex align-items-center">
          <div class="mr-auto">
            <h1 class="m-subheader__title ">Moje konto</h1>
          </div>
        </div>
      </div>
      <!-- END: Subheader -->
      <div class="m-content">
        <div class="m-portlet m-portlet--full-height  ">
          <div class="tab-content">
            <div class="">
              <div class="m-form m-form--fit m-form--label-align-right">
                <div class="m-portlet__body mb-0 pb-0">
                  <div class="form-group m-form__group m--margin-top-10 m--hide">
                  </div>
                  <div v-if="isBaseFieldEnabled('email')" class="form-group m-form__group row">
                    <div class="col-12 col-md-7">
                      <label for="email" class="form-label">
                        E-mail&nbsp;<span v-if="isRequiredField('email')">*</span>
                      </label>
                      <input id="email" class="form-control m-input" type="text" :value="user.email" disabled>
                      <b-form-text  v-if="isProfileEditEnabled" class="mt-2 text-muted text-justify">
                        Jeśli chcesz zmienić adres e-mail, skorzystaj z procedury dostępnej
                        <router-link :to="{name: 'ChangeEmail'}">tutaj</router-link>.
                      </b-form-text >
                      <b-form-text class="text-muted text-justify" v-if="fieldsDescription.hasOwnProperty('email')">
                        {{ fieldsDescription.email }}
                      </b-form-text>
                    </div>
                  </div>
                  <div v-if="isBaseFieldEnabled('name')" class="form-group m-form__group row">
                    <div class="col-12 col-md-7">
                      <label for="name" class="form-label" :class="labelClass('name')">
                        Imię&nbsp;<span v-if="isRequiredField('name')">*</span>
                      </label>
                      <b-form-input id="name"
                                    type="text"
                                    maxlength="30"
                                    :disabled="!isProfileEditEnabled"
                                    :required="isRequiredField('name')"
                                    v-model="user.name"></b-form-input>
                      <b-form-text class="text-muted text-justify" v-if="fieldsDescription.hasOwnProperty('name')">
                        {{ fieldsDescription.name }}
                      </b-form-text>
                    </div>
                  </div>
                  <div v-if="isBaseFieldEnabled('surname')" class="form-group m-form__group row">
                    <div class="col-12 col-md-7">
                      <label for="surname" class="form-label" :class="labelClass('surname')">
                        Nazwisko&nbsp;<span v-if="isRequiredField('surname')">*</span>
                      </label>
                      <b-form-input id="surname"
                                    maxlength="30"
                                    type="text"
                                    :disabled="!isProfileEditEnabled"
                                    :required="isRequiredField('surname')"
                                    v-model="user.surname"></b-form-input>
                      <b-form-text class="text-muted text-justify" v-if="fieldsDescription.hasOwnProperty('surname')">
                        {{ fieldsDescription.surname }}
                      </b-form-text>
                    </div>
                  </div>
                  <div v-if="isBaseFieldEnabled('address')" class="form-group m-form__group row">
                    <div class="col-12 col-md-7">
                      <label for="address" class="form-label" :class="labelClass('address')">
                        Ulica&nbsp;<span v-if="isRequiredField('address')">*</span>
                      </label>
                      <b-form-input id="address"
                                    maxlength="30"
                                    type="text"
                                    :disabled="!isProfileEditEnabled"
                                    :required="isRequiredField('address')"
                                    v-model="user.address"></b-form-input>
                      <b-form-text class="text-muted text-justify" v-if="fieldsDescription.hasOwnProperty('address')">
                        {{ fieldsDescription.address }}
                      </b-form-text>
                    </div>
                  </div>
                  <div v-if="isBaseFieldEnabled('city')" class="form-group m-form__group row">
                    <div class="col-12 col-md-7">
                      <label for="city" class="form-label" :class="labelClass('city')">
                        Miejscowość&nbsp;<span v-if="isRequiredField('city')">*</span>
                      </label>
                      <b-form-input id="city"
                                    type="text"
                                    maxlength="30"
                                    :disabled="!isProfileEditEnabled"
                                    :required="isRequiredField('city')"
                                    v-model="user.city"></b-form-input>
                      <b-form-text class="text-muted text-justify" v-if="fieldsDescription.hasOwnProperty('city')">
                        {{ fieldsDescription.city }}
                      </b-form-text>
                    </div>
                  </div>
                  <div v-if="isBaseFieldEnabled('postcode')" class="form-group m-form__group row">
                    <div class="col-12 col-md-7">
                      <label for="post-code" class="form-label"  :class="labelClass('postcode')">
                        Kod pocztowy&nbsp;<span v-if="isRequiredField('postcode')">*</span>
                      </label>
                      <b-form-input id="post-code"
                                    type="text"
                                    maxlength="6"
                                    :disabled="!isProfileEditEnabled"
                                    :required="isRequiredField('postcode')"
                                    v-model="user.postcode"></b-form-input>
                      <b-form-text class="text-muted text-justify" v-if="fieldsDescription.hasOwnProperty('postcode')">
                        {{ fieldsDescription.postcode }}
                      </b-form-text>
                    </div>
                  </div>
                  <div v-if="isBaseFieldEnabled('voivodeship')" class="form-group m-form__group row">
                    <div class="col-12 col-md-7">
                      <label for="voivodeship" class="form-label" :class="labelClass('voivodeship')">
                        Województwo&nbsp;<span v-if="isRequiredField('voivodeship')">*</span>
                      </label>
                      <b-form-select id="voivodeship"
                                     :options="voivodeships"
                                     :disabled="!isProfileEditEnabled"
                                     :required="isRequiredField('voivodeship')"
                                     v-model="user.voivodeship"></b-form-select>
                      <b-form-text class="text-muted text-justify" v-if="fieldsDescription.hasOwnProperty('voivodeship')">
                        {{ fieldsDescription.voivodeship }}
                      </b-form-text>
                    </div>
                  </div>
                  <div v-if="isBaseFieldEnabled('birthday')" class="form-group m-form__group row">
                    <div class="col-12 col-md-7">
                      <label for="date" class="form-label" :class="labelClass('birthday')">
                        Urodziny&nbsp;<span v-if="isRequiredField('birthday')">*</span>
                      </label>
                      <div class="input-group date">
                        <date-picker :lang="calendar.lang"
                                     format="DD.MM.YYYY"
                                     :clearable="true"
                                     :not-after="new Date()"
                                     :disabled="!isProfileEditEnabled"
                                     v-model="user.birthday"
                                     input-class="form-control"
                                     :input-attr="{required: isRequiredField('birthday')}">
                          <template slot="calendar-icon">&nbsp;</template>
                        </date-picker>
                        <div class="input-group-append d-none d-lg-flex">
                          <span class="input-group-text">
                             <i class="la la-calendar-check-o"></i>
                          </span>
                        </div>
                      </div>
                      <b-form-text class="text-muted text-justify" v-if="fieldsDescription.hasOwnProperty('birthday')">
                        {{ fieldsDescription.birthday }}
                      </b-form-text>
                    </div>
                  </div>
                  <div v-if="isBaseFieldEnabled('sex')" class="form-group m-form__group row">
                    <div class="col-12 col-md-7">
                      <label for="sex" class="form-label" :class="labelClass('sex')">
                        Płeć&nbsp;<span v-if="isRequiredField('sex')">*</span>
                      </label>
                      <b-form-select id="sex"
                                     v-model="user.sex"
                                     :disabled="!isProfileEditEnabled"
                                     :options="[
                                       {
                                         value: '',
                                         text: 'Wybierz'
                                       },
                                       {
                                         value: 'F',
                                         text: 'Kobieta'
                                       },
                                       {
                                         value: 'M',
                                         text: 'Mężczyzna'
                                       }
                                     ]"
                      ></b-form-select>
                      <b-form-text class="text-muted text-justify" v-if="fieldsDescription.hasOwnProperty('sex')">
                        {{ fieldsDescription.sex }}
                      </b-form-text>
                    </div>
                  </div>
                  <div v-if="isBaseFieldEnabled('company')" class="form-group m-form__group row">
                    <div class="col-12 col-md-7">
                      <label for="company" class="form-label" :class="labelClass('company')">
                        Firma&nbsp;<span v-if="isRequiredField('company')">*</span>
                      </label>
                      <b-form-input id="company"
                                    type="text"
                                    maxlength="300"
                                    :disabled="!isProfileEditEnabled"
                                    :required="isRequiredField('company')"
                                    v-model="user.company"></b-form-input>
                      <b-form-text class="text-muted text-justify" v-if="fieldsDescription.hasOwnProperty('company')">
                        {{ fieldsDescription.company }}
                      </b-form-text>
                    </div>
                  </div>
                  <div v-if="isBaseFieldEnabled('nip')" class="form-group m-form__group row">
                    <div class="col-12 col-md-7">
                      <label for="nip" class="form-label" :class="labelClass('nip')">
                        NIP&nbsp;<span v-if="isRequiredField('nip')">*</span>
                      </label>
                      <b-form-input id="nip"
                                    type="text"
                                    maxlength="20"
                                    :disabled="!isProfileEditEnabled"
                                    :required="isRequiredField('nip')"
                                    v-model="user.nip"></b-form-input>
                      <b-form-text class="text-muted text-justify" v-if="fieldsDescription.hasOwnProperty('nip')">
                        {{ fieldsDescription.nip }}
                      </b-form-text>
                    </div>
                  </div>
                  <div v-if="isBaseFieldEnabled('phone')" class="form-group m-form__group row">
                    <div class="col-12 col-md-7">
                      <label for="phone" class="form-label" :class="labelClass('phone')">
                        Telefon&nbsp;<span v-if="isRequiredField('phone')">*</span>
                      </label>
                      <b-form-input id="phone"
                                    maxlength="15"
                                    type="text"
                                    :disabled="!isProfileEditEnabled"
                                    :required="isRequiredField('phone')"
                                    v-model="user.phone"></b-form-input>
                      <b-form-text class="mt-2 text-muted text-justify">
                        Podaj tylko cyfry.
                      </b-form-text >
                      <b-form-text class="text-muted text-justify" v-if="fieldsDescription.hasOwnProperty('phone')">
                        {{ fieldsDescription.phone }}
                      </b-form-text>
                    </div>
                  </div>
                  <div v-for="field in additionalFields" :key="field.key" class="form-group m-form__group row">
                      <div class="col-12 col-md-7">
                        <label :for="field.key"
                               class="form-label"
                               :class="labelClass(field.key)">
                          {{ field.name }}&nbsp;<span v-if="isRequiredField(field.key)">*</span>
                        </label>
                        <b-form-input :id="field.key"
                                      type="text"
                                      v-if="parseInt(field.type) === ADDITIONAL_FIELD_TYPE_TEXT"
                                      :disabled="!isProfileEditEnabled"
                                      :required="isRequiredField(field.key)"
                                      v-model="user[field.key]"></b-form-input>

                        <tags-input v-if="parseInt(field.type) === ADDITIONAL_FIELD_TYPE_TAGS"
                                    :disabled="!isProfileEditEnabled"
                                    :field-key="field.key"
                                    @initialized="initializeTags"
                                    v-model="arrays[field.key]"/>

                        <div v-if="parseInt(field.type) === ADDITIONAL_FIELD_TYPE_SWITCH" class="d-flex align-items-center ml-1">
                          <switches :disabled="!isProfileEditEnabled"
                                    class="form-switch"
                                    :color="user[field.key] ? 'green' : 'default'"
                                    v-model="user[field.key]"></switches>
                          <label :for="field.key" class="m-0 mt-1 ml-4 p-0">
                            {{ user[field.key] ? 'Tak' : 'Nie' }}
                          </label>
                        </div>

                        <number-spinner v-if="parseInt(field.type) === ADDITIONAL_FIELD_TYPE_COUNTER"
                                        :disabled="!isProfileEditEnabled"
                                        v-model="user[field.key]"
                                        @valid="state[field.key] = null"
                                        @invalid="state[field.key] = false"
                        />

                        <radio-select-input v-if="isRadioPresentationOfSelectFieldType(field)"
                                            :description="fieldsDescription[field.key]"
                                            :disabled="!isProfileEditEnabled"
                                            :field-key="field.key"
                                            :field-columns="typeof(field.json.mk) !== 'undefined' && typeof(field.json.mk.columns) !== 'undefined'? field.json.mk.columns : 3"
                                            :options="field.json.options"
                                            v-model="user[field.key]"/>

                        <b-form-select
                                      v-if="isSelectPresentationOfSelectFieldType(field)"
                                      :description="fieldsDescription[field.key]"
                                      :disabled="!isProfileEditEnabled"
                                      :field-key="field.key"
                                      :options="addChooseOption(field.json.options)"
                                      v-model="user[field.key]"
                        ></b-form-select>

                        <multi-select-input v-if="parseInt(field.type) === ADDITIONAL_FIELD_TYPE_MULTISELECT"
                                            :disabled="!isProfileEditEnabled"
                                            :description="fieldsDescription[field.key]"
                                            :limits="getLimits(field)"
                                            :field-key="field.key"
                                            :valid-on-empty="!isRequiredField(field.key)"
                                            :options="field.json.options"
                                            :field-columns="typeof(field.json.mk) !== 'undefined' && typeof(field.json.mk.columns) !== 'undefined'? field.json.mk.columns : 3"
                                            @valid="state[field.key] = null"
                                            @invalid="state[field.key] = false"
                                            v-model="arrays[field.key]"/>

                        <b-form-text v-if="showFieldDescription(field)" class="text-muted text-justify" >
                          {{ fieldsDescription[field.key] }}
                        </b-form-text>
                      </div>
                    </div>

                </div>
                <div v-if="requiredFields.length"
                     class="m-form__seperator m-form__seperator--dashed m-form__seperator--space"></div>
                <div v-if="requiredFields.length" class="required-field-container">
                  * - Pole wymagane
                </div>
                <div v-if="isProfileEditEnabled" class="m-portlet__foot m-portlet__foot--fit">
                  <div class="m-form__actions">
                    <div class="row">
                      <div class="col-12">
                        <button href="#up" type="reset" class="btn btn-ls m-btn m-btn--air"
                                @click="updateUser">
                          Zapisz zmiany
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="isSelfRegistered" class="m-portlet m-portlet--full-height">
          <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
              <div class="m-portlet__head-title">
                <h3 class="m-portlet__head-text">
                  Usuń konto
                </h3>
              </div>
            </div>
            <div class="m-portlet__head-tools">
            </div>
          </div>
          <div class="tab-content">
            <div class="m-form m-form--fit m-form--label-align-right">
              <div class="m-portlet__body">
                <div class="row padding-0-30">
                  <div class="col-12 d-flex justify-content-between align-items-center">
                    <div>
                      Usunięcie konta jest nieodwracalne.
                    </div>
                    <button type="reset" class="btn btn-default" v-b-modal.passwordPrompt>
                      Usuń konto
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <delete-account-password-prompt-modal></delete-account-password-prompt-modal>
        </div>
      </div>
    </div>
  </page>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import {mapActions, mapGetters, mapState} from 'vuex'
import moment from 'moment'
import Page from "./Page";
import DeleteAccountPasswordPromptModal from "../modal/DeleteAccountPasswordPromptModal";
import {
  ADDITIONAL_FIELD_TYPE_COUNTER,
  ADDITIONAL_FIELD_TYPE_MULTISELECT,
  ADDITIONAL_FIELD_TYPE_SELECT,
  ADDITIONAL_FIELD_TYPE_SWITCH,
  ADDITIONAL_FIELD_TYPE_TAGS,
  ADDITIONAL_FIELD_TYPE_TEXT,
  ADDITIONAL_FIELD_SELECT_PRESENTATION,
} from "@/utils/AdditionalFieldsTypes";
import Switches from "vue-switches";
import {chunkArray} from "@/utils/ChunkArray";
import NumberSpinner from "@/components/input/NumberSpinner";
import RadioSelectInput from "@/components/input/RadioSelectInput";
import MultiSelectInput from "@/components/input/MultiSelectInput";
import TagsInput from "@/components/input/TagsInput";

const get = require('lodash.get');

  export default {
    name: "ProfilePage",
    components: {
      MultiSelectInput,
      RadioSelectInput,
      NumberSpinner,
      Switches,
      DeleteAccountPasswordPromptModal,
      Page,
      DatePicker,
      TagsInput,
    },
    data() {
      return {
        ADDITIONAL_FIELD_TYPE_TEXT: ADDITIONAL_FIELD_TYPE_TEXT,
        ADDITIONAL_FIELD_TYPE_TAGS: ADDITIONAL_FIELD_TYPE_TAGS,
        ADDITIONAL_FIELD_TYPE_SWITCH: ADDITIONAL_FIELD_TYPE_SWITCH,
        ADDITIONAL_FIELD_TYPE_COUNTER: ADDITIONAL_FIELD_TYPE_COUNTER,
        ADDITIONAL_FIELD_TYPE_SELECT: ADDITIONAL_FIELD_TYPE_SELECT,
        ADDITIONAL_FIELD_TYPE_MULTISELECT: ADDITIONAL_FIELD_TYPE_MULTISELECT,
        ADDITIONAL_FIELD_SELECT_PRESENTATION: ADDITIONAL_FIELD_SELECT_PRESENTATION,
        enabled: true,
        password: '',
        passwordError: '',
        user: {
          id: '',
          card_number: '',
          name: '',
          surname: '',
          company: '',
          nip: '',
          address: '',
          postcode: '',
          city: '',
          voivodeship: null,
          phone: '',
          email: '',
          saldo: '',
          birthday: '',
          sex: '',
          additional_field_1: '',
          additional_field_2: '',
          additional_field_3: '',
          additional_field_4: '',
          additional_field_5: '',
          additional_field_6: '',
          additional_field_7: '',
          additional_field_8: '',
          additional_field_9: '',
          additional_field_10: '',
          additional_field_11: '',
          additional_field_12: '',
          additional_field_13: '',
          additional_field_14: '',
          additional_field_15: '',
          additional_field_16: '',
          additional_field_17: '',
          additional_field_18: '',
          additional_field_19: '',
          additional_field_20: '',
        },
        arrays: {
          additional_field_1: [],
          additional_field_2: [],
          additional_field_3: [],
          additional_field_4: [],
          additional_field_5: [],
          additional_field_6: [],
          additional_field_7: [],
          additional_field_8: [],
          additional_field_9: [],
          additional_field_10: [],
          additional_field_11: [],
          additional_field_12: [],
          additional_field_13: [],
          additional_field_14: [],
          additional_field_15: [],
          additional_field_16: [],
          additional_field_17: [],
          additional_field_18: [],
          additional_field_19: [],
          additional_field_20: [],
        },
        calendar: {
          lang: {
            days: ['Nd', 'Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So'],
            months: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
            pickers: ['następne 7 dni', 'następne 30 dni', 'poprzednie 7 dni', 'poprzednie 30 dni'],
            placeholder: {
              date: 'Wybierz datę',
              dateRange: 'Select Date Range'
            }
          }
        },
        setState: false, //disable setting state before cloning
        state: {
          name: null,
          surname: null,
          company: null,
          nip: null,
          address: null,
          postcode: null,
          city: null,
          voivodeship: null,
          phone: null,
          email: null,
          saldo: null,
          birthday: null,
          sex: null,
          additional_field_1: null,
          additional_field_2: null,
          additional_field_3: null,
          additional_field_4: null,
          additional_field_5: null,
          additional_field_6: null,
          additional_field_7: null,
          additional_field_8: null,
          additional_field_9: null,
          additional_field_10: null,
          additional_field_11: null,
          additional_field_12: null,
          additional_field_13: null,
          additional_field_14: null,
          additional_field_15: null,
          additional_field_16: null,
          additional_field_17: null,
          additional_field_18: null,
          additional_field_19: null,
          additional_field_20: null,
        },
        voivodeships: [
          {value: null, text: 'Wybierz'},
          {value: '0', text: 'Dolnośląskie'},
          {value: '1', text: 'Kujawsko-pomorskie'},
          {value: '2', text: 'Lubelskie'},
          {value: '3', text: 'Lubuskie'},
          {value: '4', text: 'Łódzkie'},
          {value: '5', text: 'Małopolskie'},
          {value: '6', text: 'Mazowieckie'},
          {value: '7', text: 'Opolskie'},
          {value: '8', text: 'Podkarpackie'},
          {value: '9', text: 'Podlaskie'},
          {value: '10', text: 'Pomorskie'},
          {value: '11', text: 'Śląskie'},
          {value: '12', text: 'Świętokrzyskie'},
          {value: '13', text: 'Warmińsko-mazurskie'},
          {value: '14', text: 'Wielkopolskie'},
          {value: '15', text: 'Zachodniopomorskie'},
        ],
      }
    },
    mounted() {
      this.fetchSettings(this.entityUuid);

      //fill form immediately
      this.cloneUserFormState();

      //update form after fetch
      this.fetchUser()
        .then(() => this.cloneUserFormState())
        .then(() => this.setState = true) //unlock state setting in watchers
        .then(() => this.initializeTags())
        .then(() => this.initializeMultiSelects())
        .then(() => this.initializeSwitches())
    },
    methods: {
      ...mapActions([
        'setUser',
        'fetchUser',
        'logout',
        'setLoginInfo',
        'fetchSettings',
        'pushToFirstPage',
        'fetchAccountItems',
      ]),
      cloneUserFormState() {
        this.user = JSON.parse(JSON.stringify(this.stateUser))
      },
      cloneAgreementsFormState() {
        this.agreements = JSON.parse(JSON.stringify(this.stateAgreements))
      },
      addChooseOption(options) {
        let chooseOptions = [
            {value: null, text: 'Wybierz'}
        ];
        for (const option in options) {
          chooseOptions.push({value: options[option], text: options[option]})
        }
        return chooseOptions;
      },
      validateRequiredFields() {
        this.requiredFields.forEach((key) => {
          const field = this.getField(key);

          if (this.user.hasOwnProperty(key)
            && typeof this.user[key] !== "boolean"
            && (this.user[key] === null || !this.user[key].toString().trim().length)
            && this.state.hasOwnProperty(key)
            && (!field || parseInt(field.type) !== ADDITIONAL_FIELD_TYPE_MULTISELECT)
          ) {
            this.state[key] = false
          }

          if (field && parseInt(field.type) === ADDITIONAL_FIELD_TYPE_MULTISELECT) {
            const limitsFrom = parseInt(get(field || {}, 'json.limits.from'));
            const count = this.arrays[key].length;

            if (limitsFrom && limitsFrom > count) {
              this.state[key] = false
            }
          }
        });
      },
      updateUser() {
        this.validateRequiredFields();
        let userToUpdate = JSON.parse(JSON.stringify(this.user));
        let isSavingMissingFields = this.stateUser.missing_fields.length > 0;
        let isError = false;

        this.additionalFields.forEach((f) => {
          if (parseInt(f.type) === ADDITIONAL_FIELD_TYPE_TAGS) {
            userToUpdate[f.key] = this.arrays[f.key].map(o => o.value).join(',')
          }

          if (parseInt(f.type) === ADDITIONAL_FIELD_TYPE_MULTISELECT) {
            userToUpdate[f.key] = this.arrays[f.key].join('|')
          }

          if (parseInt(f.type) === ADDITIONAL_FIELD_TYPE_SWITCH) {
            userToUpdate[f.key] = userToUpdate[f.key] ? 1 : 0
          }
        });

        for (let property in this.state) {
          const limitsFrom = parseInt(get(this.getField(property) || {}, 'json.limits.from'));

          if (this.state.hasOwnProperty(property) && this.state[property] === false
            && (!userToUpdate[property]
                  || !userToUpdate[property].length
                  || (limitsFrom && limitsFrom > userToUpdate[property].split('|').length))
          ) {
            isError = true;
            break;
          }
        }

        if (isError) {
          this.$notify.warning('Wypełnij wszystkie pola obowiązkowe.');
          return
        }

        if (!this.isFormValid) {
          this.$notify.warning('Wypełnij formularz poprawnie.');
          return
        }

        this.$http.patch('profile', userToUpdate)
          .then((r) => {
            if (r.data.success) {
              this.setUser(r.data.user)
                .then(() => this.cloneUserFormState())
                .then(() => this.initializeTags())
                .then(() => this.initializeMultiSelects())
                .then(() => this.initializeSwitches());
            }

            if (isSavingMissingFields && this.stateUser.missing_fields.length === 0) {
              this.pushToFirstPage();
            }
          })
        .then(() => this.fetchAccountItems());
      },
      isRequiredField(field) {
        return this.requiredFields.indexOf(field) !== -1
      },
      isNumeric: function (val) {
        return /^\d*$/.test(val);
      },
      checkPattern(field,value) {
        if(field === 'phone' && value !== '' && value !== null && !this.isNumeric(value) ){
          return false;
        }
        return true;
      },
      getLimits(field) {
        return field.json.limits || {}
      },
      setFieldState(field, newValue) {
        if (!this.setState) {
          return;
        }

        const limitsFrom = parseInt(get(this.getField(field) || {}, 'json.limits.from'));
        const limitsTo = parseInt(get(this.getField(field) || {}, 'json.limits.to'));

        if (limitsFrom && limitsFrom > 0 && Array.isArray(newValue) && newValue.length < limitsFrom) {
          this.state[field] = false
        } else if (limitsTo && limitsTo > 0 && Array.isArray(newValue) && newValue.length > limitsTo) {
          this.state[field] = false
        } else if (!this.checkPattern(field,newValue)) {
          this.state[field] = false
        } else if (newValue && newValue.length) {
          this.state[field] = true
        } else if(typeof newValue === "number" && (newValue < 0 || newValue > 1000000000)) {
          this.state[field] = false
        } else if(typeof newValue === "number" && (newValue >= 0 || newValue <= 1000000000)) {
          this.state[field] = null
        } else if (this.isRequiredField(field)) {
          this.state[field] = false
        } else {
          this.state[field] = null
        }
      },
      initializeTags() {
        this.additionalFields.forEach(f => {
          if (parseInt(f.type) === ADDITIONAL_FIELD_TYPE_TAGS && this.user[f.key]) {
            this.arrays[f.key] = this.user[f.key].split(',').map(v => ({key: v, value: v}))
          }
        });
      },
      initializeMultiSelects() {
        this.additionalFields.forEach(f => {
          if (parseInt(f.type) === ADDITIONAL_FIELD_TYPE_MULTISELECT && this.user[f.key]) {
            this.arrays[f.key] = this.user[f.key].split('|');
          }
        });
      },
      initializeSwitches() {
        this.additionalFields.forEach(f => {
          if (parseInt(f.type) === ADDITIONAL_FIELD_TYPE_SWITCH && this.user.hasOwnProperty(f.key)) {
            this.user[f.key] = parseInt(this.user[f.key] || 0) !== 0
          }
        });
      },
      isBaseFieldEnabled(field) {
        if (!this.fieldsEnabled.hasOwnProperty(field)) {
          return true;
        }

        return this.fieldsEnabled[field];
      },
      chunkOptions(options, chunkSize = 2) {
        return chunkArray(options, chunkSize);
      },

      isSelectPresentationOfSelectFieldType(field) {
      return parseInt(field.type) === ADDITIONAL_FIELD_TYPE_SELECT && (typeof (field.json.mk) !== 'undefined' && field.json.mk.presentation === ADDITIONAL_FIELD_SELECT_PRESENTATION);
    },
      isRadioPresentationOfSelectFieldType(field) {
      return parseInt(field.type) === ADDITIONAL_FIELD_TYPE_SELECT && (typeof(field.json.mk) === 'undefined' || field.json.mk.presentation!==ADDITIONAL_FIELD_SELECT_PRESENTATION);
    },

      showFieldDescription(field) {
        const fieldsWithoutRegularDescription = [
            ADDITIONAL_FIELD_TYPE_SELECT,
            ADDITIONAL_FIELD_TYPE_MULTISELECT,
        ];

        if(this.isSelectPresentationOfSelectFieldType(field) && this.fieldsDescription.hasOwnProperty(field.key)){
          return true;
        }

        return fieldsWithoutRegularDescription.indexOf(parseInt(field.type)) === -1
            && this.fieldsDescription.hasOwnProperty(field.key);
      },
      labelClass(fieldKey) {
        return this.state[fieldKey] === false ? 'has-error' : '';
      }
    },
    computed: {
      ...mapState({
        stateUser: state => state.auth.user,
        entityUuid: state => state.auth.entity.uuid,
        missingFields: state => state.auth.user.missing_fields,
        disableProfileEdit: state => state.settings.disableProfileEdit,
        isSelfRegistered: state => state.auth.user.self_registered,
        requiredFields: state => state.settings.requiredFields,
        additionalFields: state => state.settings.additionalFields,
        fieldsDescription: state => state.settings.profile.fieldsDescription,
        fieldsEnabled: state => state.settings.profile.fieldsEnabled,
      }),
      ...mapGetters([
          'getField',
      ]),
      isProfileEditEnabled() {
        if (this.missingFields.length > 0) {
          return true;
        }

        return this.disableProfileEdit === '0'
      },
      isFormValid() {
        for (const [, value] of Object.entries(this.state)) {
          if (value === false) {
            return false;
          }
        }

        return true;
      }
    },
    watch: {
      'user.birthday'(newValue) {
        this.user.birthday = (newValue)
          ? moment(newValue).format('YYYY-MM-DD')
          : '';

        this.setFieldState('birthday', newValue)
      },
      'user.name'(newValue) {
        this.setFieldState('name', newValue)
      },
      'user.surname'(newValue) {
        this.setFieldState('surname', newValue)
      },
      'user.company'(newValue) {
        this.setFieldState('company', newValue)
      },
      'user.nip'(newValue) {
        this.setFieldState('nip', newValue)
      },
      'user.address'(newValue) {
        this.setFieldState('address', newValue)
      },
      'user.postcode'(newValue) {
        this.setFieldState('postcode', newValue)
      },
      'user.city'(newValue) {
        this.setFieldState('city', newValue)
      },
      'user.voivodeship'(newValue) {
        this.setFieldState('voivodeship', newValue)
      },
      'user.phone'(newValue) {
        this.setFieldState('phone', newValue)
      },
      'user.email'(newValue) {
        this.setFieldState('email', newValue)
      },
      'user.saldo'(newValue) {
        this.setFieldState('saldo', newValue)
      },
      'user.sex'(newValue) {
        this.setFieldState('sex', newValue)
      },
      'user.additional_field_1'(newValue) {
        this.setFieldState('additional_field_1', newValue)
      },
      'user.additional_field_2'(newValue) {
        this.setFieldState('additional_field_2', newValue)
      },
      'user.additional_field_3'(newValue) {
        this.setFieldState('additional_field_3', newValue)
      },
      'user.additional_field_4'(newValue) {
        this.setFieldState('additional_field_4', newValue)
      },
      'user.additional_field_5'(newValue) {
        this.setFieldState('additional_field_5', newValue)
      },
      'user.additional_field_6'(newValue) {
        this.setFieldState('additional_field_6', newValue)
      },
      'user.additional_field_7'(newValue) {
        this.setFieldState('additional_field_7', newValue)
      },
      'user.additional_field_8'(newValue) {
        this.setFieldState('additional_field_8', newValue)
      },
      'user.additional_field_9'(newValue) {
        this.setFieldState('additional_field_9', newValue)
      },
      'user.additional_field_10'(newValue) {
        this.setFieldState('additional_field_10', newValue)
      },
      'user.additional_field_11'(newValue) {
        this.setFieldState('additional_field_11', newValue)
      },
      'user.additional_field_12'(newValue) {
        this.setFieldState('additional_field_12', newValue)
      },
      'user.additional_field_13'(newValue) {
        this.setFieldState('additional_field_13', newValue)
      },
      'user.additional_field_14'(newValue) {
        this.setFieldState('additional_field_14', newValue)
      },
      'user.additional_field_15'(newValue) {
        this.setFieldState('additional_field_15', newValue)
      },
      'user.additional_field_16'(newValue) {
        this.setFieldState('additional_field_16', newValue)
      },
      'user.additional_field_17'(newValue) {
        this.setFieldState('additional_field_17', newValue)
      },
      'user.additional_field_18'(newValue) {
        this.setFieldState('additional_field_18', newValue)
      },
      'user.additional_field_19'(newValue) {
        this.setFieldState('additional_field_19', newValue)
      },
      'user.additional_field_20'(newValue) {
        this.setFieldState('additional_field_20', newValue)
      }
    },
  }
</script>

<style>
  .label-switch {
    text-align: right;
  }

  .padding-0-30 {
    padding: 0 30px;
  }

  .required-field-container {
    padding-left: 30px;
    padding-bottom: 20px;
  }
</style>
<style scoped>
#up >>> .mx-datepicker-popup {
  right: auto !important;
}

#up >>> .mx-datepicker {
  display: flex;
  flex-grow: 1;
}

#up >>> .mx-input-wrapper {
  display: flex;
  flex-grow: 1;
}

#up >>> .label-switch input[type=checkbox] {
  display: none;
}

#up >>> .form-switch {
  margin-top: 12px
}

#up >>> .m-form__group {
  padding-top: 0 !important;
  padding-bottom: 20px !important;
}


#up >>> .form-label {
  font-weight: 600 !important;
}

#up >>> .m-form__group:last-of-type {
  padding-bottom: 10px !important;
}

#up >>> .form-label.has-error {
  color: red;
}
</style>
